import { useTitle } from 'ahooks';
import { Optional } from '../util/StateArrayType';

export const usePageTitle = (title: Optional<string>) => useTitle(
  title ? `${title} | PureAdvance` : 'PureAdvance',

  { restoreOnUnmount: false },
);

